import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useCapitalIncreaseModal } from '../context/CapitalIncreaseModalContext';

const CapitalIncreaseModalHeader: FC = () => {
  const { t } = useTranslate();

  const { actions } = useCapitalIncreaseModal();

  return (
    <Modal.Header>
      <h5 className="modal-title">{t('CapitalIncrease')}&nbsp;</h5>
      <a className="close cursor-pointer" onClick={actions.handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default CapitalIncreaseModalHeader;
